<template>
  <div class="m-login__forget-password flipInX animated">
    <div id="set_password">
      <div class="m-login__head">
        <h3 class="m-login__title">Ustaw hasło</h3>
        <div class="m-login__desc">Wpisz adres e-mail podany w programie lojalnościowym, na który zostanie wysłany link
          do procedury ustawienia hasła.
        </div>
      </div>

      <b-alert class="margin-top-20"
               dismissible
               fade
               :show="showInfoAlert"
               @dismissed="showInfoAlert=false"
               variant="info">
        {{infoMessage}}
        <template slot="dismiss" class="pull-right">
          &nbsp;
        </template>
      </b-alert>

      <b-alert class="margin-top-20"
               dismissible
               fade
               :show="showErrorAlert"
               @dismissed="showErrorAlert=false"
               variant="danger">
        {{errorMessage}}
        <template slot="dismiss" class="pull-right">
          &nbsp;
        </template>
      </b-alert>

      <div class="m-login__form m-form">
        <div class="form-group m-form__group">
          <input class="form-control m-input" type="email" placeholder="E-mail" name="email" id="m_email"
                 v-model="email"
                 autocomplete="off">
        </div>
        <div class="m-login__form-action">
          <button id="m_login_set_password_submit"
                  class="btn m-btn m-btn--pill m-btn--custom m-btn--air btn-ls"
                  @click="createPasswordProcedure">
            Wyślij
          </button>
          <button id="m_login_set_password_cancel"
                  class="btn m-btn m-btn--pill m-btn--custom btn-outline-ls m-btn--hover-ls mb-2"
                  @click="setSignInForm">Anuluj
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import EmailValidator from 'email-validator';
import {ADDITIONAL_FIELDS_LIMIT} from "@/utils/ReflinkFields";

  export default {
    name: "CreatePasswordForm",
    data() {
      return {
        entity: this.entityUuid,
        email: '',
        showInfoAlert: false,
        infoMessage: '',
        showErrorAlert: false,
        errorMessage: '',
      }
    },
    methods: {
      ...mapActions([
        'setSignInForm',
        'setLoginInfo'
      ]),
      createPasswordProcedure() {
        if (!this.email.length) {
          this.showError('Musisz podać adres e-mail.');
          return;
        }

        if (!EmailValidator.validate(this.email)) {
          this.showError('Sprawdź poprawność adresu e-mail.');
          return;
        }

        let form = {
          email: this.email,
          entity: this.entityUuid
        };

        for (let i = 1; i <= ADDITIONAL_FIELDS_LIMIT; i++) {
          if (this.$route.query.hasOwnProperty(`client_additional_field_${i}`)) {
            form[`additional${i}`] = this.$route.query[`client_additional_field_${i}`]
          }
        }

        this.$http.post('password/create', form)
          .then((r) => {
            if (r.data.success) {
              this.setLoginInfo(r.data.message);
              this.setSignInForm();
            } else {
              this.showError(r.data.message);
            }
          })
      },
      showInfo(message) {
        this.showErrorAlert = false;
        this.showInfoAlert = true;
        this.infoMessage = message;
      },
      showError(message) {
        this.showErrorAlert = true;
        this.showInfoAlert = false;
        this.errorMessage = message;
      }
    },
    computed: {
      ...mapState({
        entityUuid: state => state.auth.entity.uuid,
      }),
    },
  }
</script>

<style>
  .m-login__form-action > button:first-child {
    margin-right: 5px;
    margin-bottom: 5px;
  }

  .margin-top-20 {
    margin-top: 20px;
  }

  .close {
    width: 45px;
  }

  .alert-dismissible {
    padding-right: 20px;
  }

  @media (max-width: 468px) {
    .m-login__wrapper {
      padding-right: 0 !important;
      padding-left: 0 !important;
    }
  }


</style>
